import { Component , ViewChild } from '@angular/core';
import { NavController,Content,App} from 'ionic-angular';
/*import { HttpService } from '../../../../providers/service/httpservice';

import { StorageService } from '../../../../providers/service/storageservice';
import { APP_SERVE_URL } from '../../../../providers/config/constants';
import { Utils } from '../../../../providers/service/utils';
  */
import { pinyin } from '../../../../../providers/service/pinyin';
import { ContactInfo } from '../contactinfo/contactinfo';
import { AppState } from '../../../../../app/app.global';

declare var $:any;
@Component({
  selector: 'contact-list',
  templateUrl: 'contact.html'
})
export class  ContactPage {

	@ViewChild(Content) content: Content;
	isshowsearch=false;
	timer:any;
	dataList:any[];//计算排序数据
	showList:any[];//展示数据
	firstCharList=['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P'
																		,'Q','R','S','T','U','V','W','X','Y','Z','#'];
  constructor(public navCtrl: NavController,public appCtrl: App,public global: AppState) {
  	this.dataList=[
  	{id:"1",name:"123",phone:"1523123131"},
  	{id:"12",name:"张彬21",phone:"15395182492"},
  	{id:"13",name:"张彬32",phone:"15395182492"},
  	{id:"14",name:"张彬0",phone:"15395182492"},
  	{id:"15",name:"张彬9",phone:"15395182492"},
  	{id:"16",name:"张彬8",phone:"15395182492"},
  	{id:"17",name:"张彬7",phone:"15395182492"},
  	{id:"18",name:"张彬6",phone:"15395182492"},
  	{id:"19",name:"张彬5",phone:"15395182492"},
  	{id:"10",name:"张彬3",phone:"15395182492"},
  	{id:"11",name:"张彬4",phone:"15395182492"},
  	{id:"142",name:"张彬2",phone:"15395182492"},
  	{id:"112",name:"张彬1",phone:"15395182492"},
  	{id:"114",name:"张彬22",phone:"15395182492"}
  	]
  	this.getLastDealResult();
  	console.log(this.showList);
  }

  showsearch(){
  	this.isshowsearch = !this.isshowsearch;
  }

  onCancelSearch($event:any){
  	this.isshowsearch = !this.isshowsearch;
  }

  searchNum($event:any){

  }

  contactInfo(item:any){
  	this.appCtrl.getRootNav().push(ContactInfo,{contact:item});
  }

  //获取最后处理的结果
  getLastDealResult(){
  	if(this.dataList!=null){
  		let reg = /^[A-Za-z]+$/; //如果首字符不是字母都单独提取出来
  		var length = this.dataList.length;
  		for(var i=0;i<length;i++){
  			if(this.dataList[i].name==null||this.dataList[i].name==''){//如果名称为空则自动进入  # 分类
  				this.dataList[i].firstChar = '#';
  				this.dataList[i].pinyinName ='';
  			}else{
  				this.dataList[i].pinyinName = pinyin.getFullChars(this.dataList[i].name);
  				this.dataList[i].firstChar = this.dataList[i].pinyinName.substring(0, 1);
	  			if(!reg.test(this.dataList[i].firstChar)){//如果首字符不是字母 进入 # 分类
	  				this.dataList[i].firstChar = '#';
	  			}
  			}
  		}
  		this.sortListAToZ();
  	}
  }
  //做一个排序
  sortListAToZ(){
  	this.showList = [];
  	var length = this.dataList.length;
  	var sortList:any[];
  	var char01 = '';
  	for(var i=0;i<27;i++){
  		sortList = [];
  		char01 = this.firstCharList[i];
  		for(var j=0;j<length;j++){
  			if(this.dataList[j].firstChar==this.firstCharList[i]){
  				sortList.push(this.dataList[j]);
  			}
  		}
  		if(sortList.length>0){
  			//sortList = Utils.sortList(sortList,'pinyinName');
  			sortList.sort((a: any, b: any) => {
		      if (a.pinyinName < b.pinyinName) {
		        return -1;
		      } else if (a.pinyinName > b.pinyinName) {
		        return 1;
		      } else {
		        return 0;
		      }
		    });
  			this.showList.push({id:'0000',name:char01,pinyinName:char01});
  			var length2 = sortList.length;
  			for(var h=0;h<length2;h++){
  				this.showList.push(sortList[h]);
  			}
  		}
  	}
  }

  scrollToTop() {
    this.content.scrollTo(0, 0, 200);
  }

  getDivInfo(id:string){
  	this.showChar(id);
  	if($("#"+id)[0]!=null&&$("#"+id)[0]!='undefined'&&$("#"+id)[0]!=''){
  		this.content.scrollTo(0,$("#"+id)[0].offsetTop, 200);
  	}
  }
  toBottom(){
  	this.showChar('#');
  	this.content.scrollTo(0, this.content.scrollHeight, 200);

  }

  showChar(str:string){
  	$("#showChar").html(str);
  	$("#showChar_div").show();
	  this.timer = setTimeout(()=> {
      $("#showChar").html('');
  		$("#showChar_div").hide();
    }, 400);
  }
}



// WEBPACK FOOTER //
// ./src/pages/application/dailyoffice/contact/contact/contact.ts